import * as React from 'react';
import {EventMatchLabel} from 'Src/components/EventMatchLabel/EventMatchLabel';
import BPromise from 'bluebird';
import { Component } from 'react';
import { parse } from 'query-string';
import { History, Location } from 'history';
import { AppUser } from 'Src/views/App/App';
import { SchoolEvent } from 'Src/models/event';
import { getActionList, getNextEventFilter, getPreviousEventFilter } from 'Src/helpers/event/schoolEventViewHelper';
import { Loader } from 'Src/components/Loader/Loader';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { EventActionButtonCallbacks } from '../../AdminView/TeamsAndEvents/Events/SchoolEventView/SchoolEventView';
import {
  getChildrenEvent,
  getChildrenEvents,
  sentChildrenAvailabilityReport
} from '../../../../helpers/service/parent/childrenEvents';
import { ChildrenEventMainInformation } from './MainInformation/MainInformation';
import { ChildrenSummaryTabs } from './SummaryTabs/SummaryTabs';
import { AvailabilityReportForm } from './Forms/AvailabilityReportForm';
import { getChildren } from '../../../../helpers/service/parent/children';
import {
  getNextParentEventFilter,
  getPreviousParentEventFilter
} from '../../../../helpers/event/schoolEventViewHelper';
import { getEventNameForParent } from '../../../../helpers/accessor/accessor';
import { Child } from 'Src/models/child';
import propz from 'propz';
import { Map } from 'Src/components/Map/Map';
import { getNewPoint } from 'Src/helpers/venue/venue';
import '../../AdminView/TeamsAndEvents/Events/SchoolEventView/SchoolEventPageShell.scss';
import { getActiveSchoolIdForParent } from 'Src/helpers/accessor/accessor';
import { EVENT_ACTION_BUTTONS_MAPPING } from 'Src/consts/event';
import { Report } from 'Src/models/report';
import { TABS } from 'Src/consts/common';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  setNeedUpdate?: () => void;
}

interface State {
  isLoading: boolean;
  event: SchoolEvent;
  prevEvent: SchoolEvent;
  nextEvent: SchoolEvent;
  isAvailabilityFormModalOpen: boolean;
  isSuccessModalOpen: boolean;
  isErrorModalOpen: boolean;
  errorMessage: string;
  isMapModalOpen: boolean;
  childIdList: string[];
  childrenInEvent: Child[];
  eventContentVersion: number;
  selectedAvailabilityReport?: Report;
  eventTabToOpen?: string;
}

export class ChildrenEventView extends Component<Props, State> {
  private loadRequestId = 0;
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      event: undefined,
      prevEvent: undefined,
      nextEvent: undefined,
      isAvailabilityFormModalOpen: false,
      isSuccessModalOpen: false,
      isErrorModalOpen: false,
      errorMessage: '',
      isMapModalOpen: false,
      childIdList: [],
      childrenInEvent: [],
      eventContentVersion: 0,
      selectedAvailabilityReport: undefined,
      eventTabToOpen: undefined
    };
  }

  getEventId(props: Props = this.props): string {
    const { history } = props;
    const search = parse(history.location.search);
    const eventId = search.id;
    return eventId;
  }

  //reload component after change eventId by navigation buttons
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location } = this.props;
    const { location: nextLocation } = nextProps;
    const { search } = location;
    const { search: nextSearch } = nextLocation;

    if (search !== nextSearch) {
      this.setState({
        isLoading: true
      });
      this.load(nextProps);
    }
  }

  load(props: Props = this.props) {
    const requestId = ++this.loadRequestId;
    const { user, history, location } = props;
    const eventId = this.getEventId(props);

    const calendarFilterType = propz.get(location, ['state', 'filter']);

    let event,
      prevEvent,
      nextEvent,
      childIdList,
      childrenInEvent = [];

    // Children and the selected event are independent. Load them together,
    // then resolve previous/next navigation once their shared filters are known.
    BPromise.all([getChildren(user), getChildrenEvent(user, eventId)])
      .then(([children, selectedEvent]) => {
        event = selectedEvent;
        childIdList = children.map(child => child.id);
        const playersIdList = (event.players || []).map(player => player.userId);
        childrenInEvent = children.filter(child =>
          playersIdList.some(playerId => String(playerId) === String(child.id))
        );

        const currentEventStartTime = new Date(selectedEvent.startTime);
        const nextEventFilter = getNextParentEventFilter(
          eventId,
          currentEventStartTime,
          childIdList,
          calendarFilterType
        );
        const prevEventFilter = getPreviousParentEventFilter(
          eventId,
          currentEventStartTime,
          childIdList,
          calendarFilterType
        );

        return BPromise.all([getChildrenEvents(user, prevEventFilter), getChildrenEvents(user, nextEventFilter)]);
      })
      .then(([_prevEvent, _nextEvent]) => {
        if (requestId !== this.loadRequestId) return;
        [prevEvent] = _prevEvent;
        [nextEvent] = _nextEvent;

        this.setState({
          isLoading: false,
          event,
          nextEvent,
          prevEvent,
          childIdList,
          childrenInEvent,
          eventTabToOpen: propz.get(location, ['state', 'initialTab'])
        });
      })
      .catch(error => {
        if (requestId !== this.loadRequestId) return;
        console.error(error);
        const status = propz.get(error, ['response', 'status']);
        if (status === 403 || status === 404) {
          history.push({ pathname: '/calendar' });
          return;
        }
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage:
            propz.get(error, ['response', 'data', 'details', 'text']) ||
            'The event could not be loaded. Please try again.'
        });
      });
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.load();
  }

  componentDidUpdate(_prevProps: Props, prevState: State) {
    if (this.state.event && this.state.event !== prevState.event) {
      const eventName = getEventNameForParent(this.state.event, this.state.childIdList);
      window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: eventName }));
    }
  }

  componentWillUnmount() {
    this.loadRequestId += 1;
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
  }

  onPrevEventClick = () => {
    const { prevEvent } = this.state;
    const { history, location } = this.props;
    const { id } = prevEvent;
    const state = propz.get(location, ['state'], {});

    history.push({
      pathname: '/events/event',
      search: `id=${id}`,
      state
    });
  };

  onNextEventClick = () => {
    const { nextEvent } = this.state;
    const { history, location } = this.props;
    const { id } = nextEvent;
    const state = propz.get(location, ['state'], {});

    history.push({
      pathname: '/events/event',
      search: `id=${id}`,
      state
    });
  };

  openAvailabilityModal = (report?: Report) => {
    this.setState({
      isAvailabilityFormModalOpen: true,
      selectedAvailabilityReport: report
    });
  };

  closeAvailabilityFormModal = () => {
    this.setState({
      isAvailabilityFormModalOpen: false,
      selectedAvailabilityReport: undefined
    });
  };

  onSubmit = data => {
    const { user } = this.props;
    const { event } = this.state;

    this.setState({
      isLoading: true
    });

    sentChildrenAvailabilityReport(user, event.id, data)
      .then(() => {
        this.setState(previousState => ({
          isAvailabilityFormModalOpen: false,
          selectedAvailabilityReport: undefined,
          isSuccessModalOpen: true,
          isLoading: false,
          eventContentVersion: previousState.eventContentVersion + 1,
          eventTabToOpen: TABS.AVAILABILITY_REPORTS
        }));
        if (this.props.setNeedUpdate) this.props.setNeedUpdate();
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage:
            propz.get(error, ['response', 'data', 'details', 'text']) ||
            'Your availability could not be sent. Please try again.'
        });
      });
  };

  renderAvailabilityFormModal = () => {
    const { isAvailabilityFormModalOpen, childrenInEvent, selectedAvailabilityReport } = this.state;
    return (
      <SimpleModal
        isOpen={isAvailabilityFormModalOpen}
        customClass="parentCompactModal"
        showHeader={false}
        showFooter={false}
      >
        <AvailabilityReportForm
          key={selectedAvailabilityReport?.id || 'new-availability-report'}
          childrenInEvent={childrenInEvent}
          initialReport={selectedAvailabilityReport}
          onCancel={this.closeAvailabilityFormModal}
          onSubmit={this.onSubmit}
        />
      </SimpleModal>
    );
  };

  closeSuccessModal = () => {
    this.setState({
      isSuccessModalOpen: false
    });
  };

  renderSuccessModal() {
    const { isSuccessModalOpen } = this.state;
    return (
      <SimpleModal
        isOpen={isSuccessModalOpen}
        title="Availability sent"
        body="Your availability response has been sent to the school."
        buttonCancelText={'Ok'}
        onCloseClick={this.closeSuccessModal}
        customClass={'eChangePasswordTabModal'}
        dialogStyle={{ maxWidth: 520 }}
      />
    );
  }

  closeErrorModal = () => this.setState({ isErrorModalOpen: false });

  renderErrorModal() {
    const { isErrorModalOpen, errorMessage } = this.state;
    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title="Availability not sent"
        body={errorMessage}
        buttonCancelText="Close"
        onCloseClick={this.closeErrorModal}
        dialogStyle={{ maxWidth: 520 }}
      />
    );
  }

  emptyFunc = () => {};

  getCallbacks(): EventActionButtonCallbacks {
    return {
      EDIT_EVENT_SETTINGS: this.emptyFunc,
      DUPLICATE_EVENT: this.emptyFunc,
      ADD_SCHOOL: this.emptyFunc,
      ADD_TEAM: this.emptyFunc,
      ADD_RESULTS: this.emptyFunc,
      UPDATE_RESULTS: this.emptyFunc,
      UPDATE_POINTS: this.emptyFunc,
      SEND_CONSENT_REQUEST: this.emptyFunc,
      CANCEL_EVENT: this.emptyFunc,
      CANCEL_EVENT_AND_EDIT_NOTIFICATION_LIST: this.emptyFunc,
      UNCANCEL_EVENT: this.emptyFunc,
      REPORT_AVAILABILITY: this.openAvailabilityModal,
      PRINT: this.emptyFunc,
      DOWNLOAD_CSV: this.emptyFunc,
      DELETE_EVENT: this.emptyFunc,
      IMPORT_RESULTS_FROM_QUANTUM: this.emptyFunc,
      EXPORT_START_LIST_TO_MACSHA_ONE_4_ALL: this.emptyFunc,
      IMPORT_RESULTS_FROM_MACSHA_ONE_4_ALL: this.emptyFunc,
      CLEAN_SCHOOL_LIST: this.emptyFunc,
      SEND_EVENT_NOTIFICATION: this.emptyFunc,
      SEND_EVENT_NOTIFICATION_ELIGIBLE_STUDENTS: this.emptyFunc,
      IMPORT_RESULTS: this.emptyFunc,
      IMPORT_RESULTS_FROM_QUANTUM_AQ: this.emptyFunc,
      CLONE_TOURNAMENT_EVENT: this.emptyFunc,
      ARBITER_BOARD: this.emptyFunc,
      ADD_VIDEO: this.emptyFunc
    };
  }

  renderMapModal() {
    const { isMapModalOpen, event } = this.state;

    const { venue } = event;
    const point = getNewPoint(venue);
    const { coordinates } = point;
    const [latitude, longitude] = coordinates;

    return (
      <SimpleModal isOpen={isMapModalOpen} title={'Venue'} buttonCancelText={'Close'} onCloseClick={this.closeMapModal}>
        <Map point={point} customStylingClass="mb-3 eClubWizardMap" isMarkerDraggable={false} />
        <div>
          <a
            target="_blank"
            href={`http://maps.google.com/maps?q=${longitude},${latitude}+(My+Point)&z=14&ll=${longitude},${latitude}`}
          >
            View on Google Maps
          </a>
        </div>
      </SimpleModal>
    );
  }

  openMapModal = () => {
    this.setState({
      isMapModalOpen: true
    });
  };

  closeMapModal = () => {
    this.setState({
      isMapModalOpen: false
    });
  };

  goBack = () => {
    const { event } = this.state;
    const { history, location } = this.props;
    const { state } = location;
    const { prevRoutePath, filter } = state as any;

    const selectedDate = propz.get(event, ['startTime']);

    const isSelectedDateExist = typeof selectedDate !== 'undefined';
    const isFilterExist = typeof filter !== 'undefined';

    const data: any = {
      pathname: prevRoutePath,
      state: {}
    };

    if (isFilterExist) data.state.filter = filter;
    if (isSelectedDateExist) {
      data.state.selectedDate = selectedDate;
    }

    history.push(data);
  };

  render() {
    const {
      isLoading,
      prevEvent,
      nextEvent,
      event,
      childIdList,
      childrenInEvent,
      eventContentVersion,
      eventTabToOpen
    } = this.state;
    const { user, location } = this.props;

    const prevRoutePath = propz.get(location, ['state', 'prevRoutePath']);
    const isPrevRoutePathExist = typeof prevRoutePath !== 'undefined' && prevRoutePath !== '';

    if (isLoading) {
      return <Loader />;
    }

    const isPrevEventExist = typeof prevEvent !== 'undefined';
    const isNextEventExist = typeof nextEvent !== 'undefined';

    const eventName = getEventNameForParent(event, childIdList);
    const activeSchoolId = getActiveSchoolIdForParent(event, childIdList);
    const eventChild = childrenInEvent.find(child => String(child.schoolId) === String(activeSchoolId));
    const availabilityParentEnabled =
      typeof (eventChild && eventChild.availabilityParentEnabled) === 'boolean'
        ? eventChild.availabilityParentEnabled
        : String(user.activeSchoolId) === String(activeSchoolId) && user.activeSchool.settings.availabilityParentEnabled;
    const photosEnabled =
      typeof (eventChild && eventChild.photosEnabled) === 'boolean'
        ? eventChild.photosEnabled
        : String(user.activeSchoolId) === String(activeSchoolId) && user.activeSchool.settings.photosEnabled;
    const eventUser = activeSchoolId
      ? {
          ...user,
          activeSchoolId,
          activeSchool: {
            ...user.activeSchool,
            settings: {
              ...user.activeSchool.settings,
              availabilityParentEnabled: Boolean(availabilityParentEnabled),
              photosEnabled: Boolean(photosEnabled)
            }
          }
        }
      : user;
    const availabilityAction = getActionList(eventUser, event, this.getCallbacks()).find(
      item => item.itemText === EVENT_ACTION_BUTTONS_MAPPING.REPORT_AVAILABILITY
    );
    const isSelfServiceAvailability =
      String(propz.get(eventUser, ['activeSchool', 'settings', 'availabilityWorkflow'], 'SELF_SERVICE')) ===
      'SELF_SERVICE';
    const canRespondToAvailability = Boolean(availabilityAction) || !isSelfServiceAvailability;
    const classes = 'schoolEventPage';

    return (
      <div className={classes}>
        {this.renderAvailabilityFormModal()}
        {this.renderSuccessModal()}
        {this.renderErrorModal()}
        {this.renderMapModal()}

        <header className="schoolEventPage__header">
          <div className="schoolEventPage__backRow">
            <button type="button" onClick={isPrevRoutePathExist ? this.goBack : () => this.props.history.goBack()}>
              <span aria-hidden="true">←</span> Back to events
            </button>
            <span className="schoolEventPage__backDivider" aria-hidden="true" />
            <strong>{eventName}</strong>
          </div>
          <EventMatchLabel event={event} />
          <ChildrenEventMainInformation
            user={eventUser}
            event={event}
            eventName={eventName}
            activeSchoolId={activeSchoolId}
            isPrevButtonDisabled={!isPrevEventExist}
            isNextButtonDisabled={!isNextEventExist}
            onPrevEventClick={this.onPrevEventClick}
            onNextEventClick={this.onNextEventClick}
            onReportAvailabilityClick={availabilityAction && isSelfServiceAvailability ? () => this.openAvailabilityModal() : undefined}
            onViewMapClick={this.openMapModal}
          />
        </header>
        <section className="schoolEventPage__workspace">
          <ChildrenSummaryTabs
            key={`${event.id}:${eventContentVersion}`}
            user={eventUser}
            eventInitial={event}
            eventName={eventName}
            childrenInEvent={childrenInEvent}
            onConsentChange={this.props.setNeedUpdate}
            onEditAvailability={canRespondToAvailability ? this.openAvailabilityModal : undefined}
            initialTab={eventTabToOpen}
            initialConversationId={propz.get(this.props.location, ['state', 'conversationId'])}
          />
        </section>
      </div>
    );
  }
}
